import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ModuleHeader from "@components/ModuleHeader";

import '@assets/css/dashboard.css';

const EmptyScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/dashboard`);
  }, [navigate]);

  return (
    <div className='module empty-screen'>
      <ModuleHeader />
    </div>
  );
};

export default EmptyScreen;
